<template>
  <div
    :class="[
      'd-flex primary--text text-uppercase font-weight-black',
      className,
      !small ? 'text-h5  text-md-h4' : 'text-h6 text-md-h5',
    ]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: "center",
      validator: (val) => ["left", "center", "right"].includes(val),
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    className() {
      const classNameAlign = {
        left: "text-left justify-start",
        center: "text-center justify-center",
        right: "text-right justify-end",
      };

      return classNameAlign[this.align] || "";
    },
  },
};
</script>

<style>
.title-widget {
  display: inline-block;
  color: #1e1e1e;
}
</style>
